<template lang="">
    <div>
           <!--begin::Mixed Widget 1-->
  <div class="card card-custom bg-gray-100">
    <!--begin::Header-->
    <div class="card-header border-0 blue lighten-2 ">
      <h3 class="card-title font-weight-bolder text-white">
        Creador Departamental | {{nombreDepartamento}}
      </h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body">
      <!--begin::Chart-->
      
      <!--end::Chart-->
      <!--begin::Stats  mt-n25-->
      <div class="card-spacer">
        <!--begin::Row-->
        <div class="row m-0 text-center">
          
          <div class="col bg-light-primary px-6 py-8 rounded-xl mb-7 col-md-6 col-sm-12">
            <span class="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
              <inline-svg src="media/svg/icons/Communication/Add-user.svg" />
            </span>
            <router-link
                to="/admin/informadores-municipales"
                v-slot="{ href, navigate, isActive, isExactActive }"
                >
                <a :href="href" class="text-primary font-weight-bold font-size-h6| mt-2">
                Administrar Informadores Municipales
                </a>
            </router-link>
          </div>
        </div>
        <!--end::Row-->
       
        
      </div>
      <!--end::Stats-->
      <!--end::Body-->
    </div>
    <!--end::Mixed Widget 1-->
  </div>
    </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
export default {
    name: "DashboardInformador",
    data() {
       return {
        strokeColor: "#D13647",
        chartOptions: {},
        nombreDepartamento:'',
        series: [
            {
            name: "Net Profit",
            data: [30, 45, 32, 70, 40, 40, 40]
            }
        ]
        };
    },
    computed: {
    ...mapGetters(["layoutConfig"])
  },
  created(){
      this.nombreDepartamento = window.localStorage.getItem('creadorDepartamentoNombre');
  },
  mounted() {
       this.$store.dispatch(SET_BREADCRUMB, [{ title: "Inicio" }]);
    // reference; kt_mixed_widget_1_chart
    this.chartOptions = {
      chart: {
        type: "area",
        height: 200,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        sparkline: {
          enabled: true
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 5,
          left: 0,
          blur: 3,
          color: this.strokeColor,
          opacity: 0.5
        }
      },
      plotOptions: {},
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: "solid",
        opacity: 0
      },
      stroke: {
        curve: "smooth",
        show: true,
        width: 3,
        colors: [this.strokeColor]
      },
      xaxis: {
        categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        tooltip: {
          enabled: false
        },
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        },
        crosshairs: {
          show: false,
          position: "front",
          stroke: {
            color: this.layoutConfig("colors.gray.gray-300"),
            width: 1,
            dashArray: 3
          }
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 80,
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0
          }
        },
        hover: {
          filter: {
            type: "none",
            value: 0
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0
          }
        }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        y: {
          formatter: function(val) {
            return "$" + val + " thousands";
          }
        },
        marker: {
          show: false
        }
      },
      colors: ["transparent"],
      markers: {
        colors: [this.layoutConfig("colors.theme.light.danger")],
        strokeColor: [this.strokeColor],
        strokeWidth: 3
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0
        }
      }
    };
  }
}
</script>
<style lang="">
    
</style>